import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesFieldSchemesAddRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-field-schemes-add',
	path: '/secure/admin/AddFieldConfigurationScheme!default.jspa',
};
